import React from "react";

/** Shown to a player the game can no longer reach. */
const ReachWarning: React.FC<{ onFix: () => void }> = ({ onFix }) => (
  <div className="gm-warning" role="alert">
    <span>We can&apos;t reach you right now. Turn notifications back on or link Telegram.</span>
    <div>
      <button type="button" className="gm-button gm-button--plain" onClick={onFix}>
        Fix it
      </button>
    </div>
  </div>
);

export default ReachWarning;
